import BenchlingConfig from 'BenchlingConfig';
import EntityStore from 'stores/EntityStore';

export const TEXT_FIELD_BACKGROUND_COLOR = 'rgba(232, 240, 242, 0.5)';

export const TEXT_FIELD_BORDER = '1px solid #F5F8FA';

export function isMonomerManagementEnabledForUser(): boolean {
  const currentUser = EntityStore.currentUser();
  return currentUser?.isTenantAdmin && BenchlingConfig.MOLBIO_ENABLE_MODIFIED_NUCLEOTIDES;
}
